export const WHITELISTED_AUTHORS = [
  'NewMediaWire',
  'PressAdvantage',
  'InvestorBrandMedia',
  'Evertise',
  'InvestorBrandNetwork',
  'Newsworthy.ai',
  'Law Firm Newswire',
  'New York Tech',
  'Send2Press',
  'Reportable News',
  '24-7 Press Release',
  'Media OutReach',
  'PRLog',
  'King Newswire',
  'eTrendy Stock',
  'Globe PR Wire',
  'Press Services',
  'Sage Potash',
  'Golden Spike Resources',
  'EdgeClear',
  'Chainwire',
  'PRWire Center',
  'Emily Lew',
  'Jeannine Mancini',
  'Kaili Killpack',
  'Claire Shefchik',
  'Davit Kirakosyan',
  'Adrian Volenik',
  'AJ Fabino',
  'LaToya Scott',
  'Margaret Jackson',
  'Jeff Vasishta',
  'Eric Mcconnell',
  'Paula Tudoran',
  'Finance Wire',
];

export const MARKET_MOVING_EXCLUSIVES_CHANNEL_ID = 165347;
